module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_800x400@2x-bfa845ccdc94eefb1932b1f65a68c596.jpg";